// Constants
import { Color } from "../../constants/Colors";
export const useStyles = (color) => {
    return {
        multiValue: (provided, state) => (Object.assign(Object.assign({}, provided), { padding: '2px 10px 2px 10px', background: Color.gradient[100], borderRadius: 16 })),
        multiValueLabel: (provided, state) => (Object.assign(Object.assign({}, provided), { color: Color.neutral[0], fontFamily: "roboto", fontSize: "12px", fontWeight: "normal", letterSpacing: "0px" })),
        multiValueRemove: (provided, state) => (Object.assign(Object.assign({}, provided), { cursor: 'pointer', 
            // borderRadius: `50%`,
            "& svg": {
                width: 16,
                height: 16,
                color: Color.neutral[0],
                // padding: 0,
                // margin: 0,
            }, "&:hover": {
                background: 'transparent',
            } })),
        control: (provided, state) => (Object.assign(Object.assign({}, provided), { borderRadius: "0px", minHeight: "44px", border: "none", boxShadow: "none", borderBottom: `2px solid ${Color.primary[600]}`, "&:hover": {
                border: "none",
                borderBottom: `2px solid ${Color.primary[600]}`,
            }, background: color === "grey" ? Color.neutral[100] : Color.neutral[0] })),
        dropdownIndicator: (provided, state) => (Object.assign(Object.assign({}, provided), { display: "none" })),
        indicatorSeparator: (provided, state) => (Object.assign(Object.assign({}, provided), { display: "none" })),
        placeholder: (provided, state) => (Object.assign(Object.assign({}, provided), { fontFamily: "roboto", color: Color.neutral[400] })),
        menu: (provided, state) => (Object.assign(Object.assign({}, provided), { fontFamily: "roboto" })),
    };
};
